import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import Button from 'react-bootstrap/Button';

import usersService from '../../../../services/Users';
import empresasService from '../../../../services/Empresas';

import { IconContext } from "react-icons";
import { FiUserPlus } from "react-icons/fi";

import Swal from 'sweetalert2'
import { Card, Checkbox, Select, Switch } from 'antd';
import PAISES from '../../../../constantes/paises';

const { Option } = Select;

// ESTILO DEL MODAL DE INVITACION DE USUARIO
const customStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    background            : 'white'
  }
};

const EmpresasModal = ({ open, handlerClose, usuario, reloadUsers }) => {

  const [ companiesSelected, setCompaniesSelected ] = useState( [...(usuario.companiesEnabled ?? [])] )
  const [ empresas, setEmpresas ] = useState({ loading: true })
  useEffect( () => {
    setEmpresas({ loading: true })
    empresasService.get()
      .then( response => {
        setEmpresas( { loading: false, data: response.data.info } )
      })

  }, [])

  // FUNCION DE CREACION DE ZONA
  const updateUser = ( ) => {


    // CAPTURO LOS DATOS PARA ENVIAR A LA API POST /ZONES
    const jsonData = {
      _id: usuario._id,
      companiesEnabled: companiesSelected
    }

    // LE PEGO A LA API Y AL FINALIZAR LLAMO AL HANDLER DE SUCCESS Y CIERRO EL ALERT
    usersService.putCompanies( jsonData )
        .then(reloadUsers)
        .finally(() => {
            Swal.close();
        })

  }

  // RENDERIZADO DEL COMPONENTE MODAL
  return (
    <div>
      <Modal
              isOpen={ open }
              onRequestClose={ handlerClose }
              style={ customStyles }
              appElement={ document.getElementById('root') }
            >

        {
          empresas.loading
          ?
          <div className="modalContainer">
            <img src="/assets/img/icons/loading.svg" alt="loading"></img>
          </div>
          :
          <div className="modalContainer">
            <div className='title'>{ usuario.nombre } { usuario.apellido }</div>
            <div className="data" style={{ maxHeight: '50vh', overflow: 'auto' }}>
                {
                    empresas.data.map( empresa => {
                        if ( empresa.pais === usuario.pais ){
                            return (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '5px 0', paddingRight: '100px' }}>
                                    <Checkbox checked={ companiesSelected.indexOf( empresa._id ) > -1 } onChange={ ev => setCompaniesSelected( prev => ev.target.checked ? [ ...prev, empresa._id ] : prev.filter( eId => eId !== empresa._id ) ) } />
                                    <div> {empresa.nombre} </div>
                                </div>
                            )
                        }
                    })
                }  
            </div>
            <div className="footer" style={{ marginTop: '10px' }}>
            <Button block variant="primary" onClick={ updateUser }> Guardar </Button>
            </div>
          </div>
        }

      </Modal>
    </div>
  )
}

export default EmpresasModal
